import React, { Component } from "react";
import Hero from "./../../components/hero";
import { Colors } from "./../../utils/variables";
import ScrollFadeIn from "./../../components/scrollFadeIn";
import FAQ from "./../../components/faq";

export default class FaqPage extends Component {
  componentDidMount = () => {
    window.scrollTo(0, 0);
  };

  render() {
    return (
      <div className="light-grey-background" style={{ backgroundColor: Colors.primaryDark }}>
        <div className="slant-bottom">
          <Hero
            title={"FAQ"}
            subtitle={"Frequently asked questions"}
            backgroundImage={"/images/landscape.jpg"}
            height={"half"}
            tint={""}
          />
        </div>
        <ScrollFadeIn>
          <div className="large-padding" style={{ color: Colors.white, backgroundColor: Colors.primary }}>
            <FAQ showTitle={false} />
          </div>
        </ScrollFadeIn>
      </div>
    );
  }
}
